export const drawerWidthEnum = {
  minWidth: 104,
  maxWidth: 270
}

export const dutyTypeEnum = {
  airpotTransfer: 1,
  rental: 2,
  outstation: 3,
  outstationRoundTrip: 4,
};

export const tripDutyTypeEnum = {
  airpotTransfer: 4,
  rental: 5,
  oneWayTrip: 6,
  roundTrip: 7,
}


export const billingTypeEnum = {
  billToCreditCard: 1,
  billToCompany: 2,
  billToCreditCardAndbillToCompany: 3
}

export const complianceExpiryMaxDate ='9999-05-31'

export const imageSize = {
  fileSize : 1048576,
  fiveMb : 5120000
}

export const minDate = '1950-01-01'

export const nightAllowanceTime ={
  start:21,
  end:6
} 

export const rateCardFiltersEnum = {
  cityType: "cityType",
  dutyType: "dutyType",
  carType: "carType",
  subCityType: "subCityType"
}

export const businessTypeData = {
  coorporate:'0',
  public:'1',
  both:'2'
}

export const vehicelPriority = 
  [
  { value: '1', label: 'Priority 1' },
  { value: '2', label: 'Priority 2' },
  { value: '3', label: 'Priority 3' },
  { value: '4', label: 'Priority 4' },
]